export const ALERTS_OF_VULNERABILITY_PAGES_ORDER_FOR_PERMISSIONS: string[] = [
  'dashboard',
  'case',
  'alert_follow_up_action',
  'public_agent_module_permission',
  'group_module_permission',
  'alert_type',
]
